import VueNotifications from 'vue-notifications';

export default {
	name: 'Notificacion',
	notifications: {
		showSuccessMsg: {
			type: VueNotifications.types.success,
			title: 'Excelente',
			message: 'That\'s the success!'
		},
		showInfoMsg: {
			type: VueNotifications.types.info,
			title: 'Hey',
			message: 'Here is some info for you'
		},
		showWarnMsg: {
			type: VueNotifications.types.warn,
			title: 'Wow',
			message: 'That\'s the kind of warning'
		},
		showErrorMsg: {
			type: VueNotifications.types.error,
			title: 'Wow-wow',
			message: 'That\'s the error'
		}
	}
}